import { useContext, useEffect, useRef, useState } from 'react';
import ApiContext from 'src/provider/API/call-service';
import { CustomContainer } from 'src/style';
import { Filter, Portal, ServerSideTable } from 'src/component';
import { monthlyBillingReportColumns } from 'src/utils/table-layout';
import helpers from 'src/utils/helpers';

export const MonthlyBillingReport = () => {
  const { API, downloadReport } = useContext(ApiContext);
  const [reportData, setReportData] = useState<any>(null);
  const [report, setReport] = useState<any>(null);
  const [resetPagination, setResetPagination] = useState<boolean>(false);
  const [view, setView] = useState<string>('');
  const filterDataRef = useRef({});

  useEffect(() => {
    filterDataRef.current = {};
    handleFetchMonthlyBillingReport();
  }, []);

  async function handleFetchMonthlyBillingReport(
    pageNumber = 1,
    pageSize = 10,
    isDownload = false
  ) {
    const response = await API.getMonthlyBillingReport({
      pageNumber,
      pageSize,
      ...filterDataRef.current,
      returnMax: isDownload,
    });

    if (response) {
      if (isDownload) {
        return downloadReport(response, 'MONTHLY_BILLING_REPORT');
      }

      response.data = helpers.addSerialNumberToItems(response?.data, {
        pageNumber,
        pageSize,
      });

      setReportData(response);
      setReport(response.data);
    }
  }
  function handleClear() {
    filterDataRef.current = {};
    handleFetchMonthlyBillingReport();
    setResetPagination(!resetPagination);
  }

  async function handleAction(rowData: any) {
    const response = await API.retryFailedMonthlyBilling(rowData?.id);
    if (response) handleFetchMonthlyBillingReport();
  }

  return (
    <>
      <CustomContainer>
        <ServerSideTable
          tableData={report}
          tableColumns={monthlyBillingReportColumns(handleAction)}
          dataFetchMethod={handleFetchMonthlyBillingReport}
          totalRows={reportData?.total}
          customStyle
          shouldResetPagination={resetPagination}
          canFilter={() => setView('filter')}
          canClear={handleClear}
          downloadAction={() => handleFetchMonthlyBillingReport(1, 10, true)}
        />
      </CustomContainer>
      {view === 'filter' && (
        <Portal>
          <Filter
            type="monthly-billing-report"
            onApplyFilter={handleFetchMonthlyBillingReport}
            setFilterData={(data: any) => {
              filterDataRef.current = data;
            }}
            close={() => setView('')}
            top="35"
          />
        </Portal>
      )}
    </>
  );
};
